import {StipStatus} from '@deliveriesondemand/dod-data';

import {StipStatusIcons} from '-/icons/icons';

const StipDocStatus = (props) => {
    const {doc} = props;
    return (
        <div>
            <p className="info">
                {doc.title}
                <br/>
                <img src={StipStatusIcons[doc.status]} />
                <strong>{StipStatus[doc.status]}</strong>
            </p>
        </div>
    );
};

export default StipDocStatus;
